import Editor from 'vue-image-markup'
import Vue from 'vue'

Vue.component('Editor', Editor)
